import { memo } from "react";
import PropTypes from "prop-types";
import Separator from "app/pages/.shared/Separator";
import "./StaticPage.scss";
import LoaderBar from "app/pages/.shared/LoaderBar/LoaderBar";

import { DynamicBlocksRendererContainer } from "app/pages/.shared/DynamicBlocks";
import Paragraphs from "app/pages/.shared/Paragraphs";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

const StaticPage = ({ blocks = [], titleBlock = {}, title }) => {
	const titleStyle = {
		textAlign: titleBlock?.position || "center",
		justifyContent: titleBlock?.position || "center",
	};

	return (
		<div className="static-page">
			{blocks.length > 0 ? (
				<div className="static-page__container">
					<Typography
						variant={TYPOGRAPHY_VARIANTS.XL4}
						isBold
						className="static-page__container-title"
						component="h1"
						style={titleStyle}
					>
						<Paragraphs
							paragraphs={titleBlock.label ? titleBlock.label : title}
							enableHTMLFormatting
						/>
					</Typography>

					<section className="static-page__container-content">
						<DynamicBlocksRendererContainer
							blocks={blocks}
							dividerComponent={<Separator design="middle" />}
						/>
					</section>
				</div>
			) : (
				<div className="static-page__container">
					<section className="static-page__container-content">
						<div className="static-page__placeholder">
							<LoaderBar />
							<LoaderBar />
							<LoaderBar />
							<LoaderBar />
							<LoaderBar />
							<LoaderBar />
							<LoaderBar />
							<LoaderBar />
							<LoaderBar />
							<LoaderBar />
							<LoaderBar />
							<LoaderBar />
						</div>
					</section>
				</div>
			)}
		</div>
	);
};

StaticPage.propTypes = {
	blocks: PropTypes.array,
	titleBlock: PropTypes.object,
	title: PropTypes.string,
};

export default memo(StaticPage);
